import { render } from "./IngresosMensualesSoloLectura.vue?vue&type=template&id=744ab97a"
import script from "./IngresosMensualesSoloLectura.vue?vue&type=script&lang=js"
export * from "./IngresosMensualesSoloLectura.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__